module.exports = __webpack_public_path__ + "media/images/home/flipcard_teacher-a6221642537824878f66948a50a6907e.svg";